import { create } from 'zustand'
import { PaymentMethod, TspPaymentStep } from '@entities/payment/@x/tsp'
import { ServerOption } from '@entities/server/@x/tsp'
import { Amount } from '@root/api/ump-ewallet'
import { PaymentDenomination, PaymentPayee } from './tsp.types'

export interface CyberState {
  step: TspPaymentStep
  setStep: (step: TspPaymentStep) => void
  activeService: PaymentPayee | null
  setActiveService: (service: PaymentPayee) => void
  providerURL: string
  setProviderURL: (url: string) => void
  h1: string
  setH1: (h1: string) => void
  linkedTsp?: PaymentPayee
  setLinkedTsp: (tsp: PaymentPayee) => void
  countryVouchers: { country: string; icon: string }[]
  setCountryVouchers: (vouchers: { country: string; icon: string }[]) => void
  denominationsByCountry: Record<string, PaymentDenomination[]>
  setdenominationsByCountry: (vouchers: Record<string, PaymentDenomination[]>) => void
  paymentMethod: PaymentMethod
  setPaymentMethod: (method: PaymentMethod) => void
  amountInfo: Amount | null
  setAmountInfo: (amount: Amount | null) => void
  activeCountry: string | null
  setActiveCountry: (country: string | null) => void
  activeDenomination: PaymentDenomination | null
  setActiveDenomination: (denomination: PaymentDenomination | null) => void
  activeCountrySteam: string
  setActiveCountrySteam: (country: string) => void
  requestID: string
  setRequestID: (requestID: string) => void
  handleClickScrollToAccordion: () => void
  setHandleClickScrollToAccordion: (fn: () => void) => void
  isPaymentloading: boolean
  isAmountInfoLoading: boolean
  setPaymentLoading: (loading: boolean) => void
  setIsAmountInfoLoading: (isLoading: boolean) => void
  pcekMdOrder: string
  setPcekMdOrder: (mdOrder: string) => void
  servers: ServerOption[] | null
  setServers: (servers: ServerOption[]) => void
  isPromocodeActivated: boolean
  setIsPromocodeActivated: (isPromocodeActivated: boolean) => void
  lastActivatedPromocode: string
  setLastActivatedPromocode: (lastActivatedPromocode: string) => void
}

export const useCyberStore = create<CyberState>((set) => ({
  step: TspPaymentStep.SERVICES_FORM,
  setStep: (step) => set({ step }),
  activeService: null,
  setActiveService: (service) => set({ activeService: service }),
  providerURL: '',
  setProviderURL: (url) => set({ providerURL: url }),
  h1: '',
  setH1: (h1) => set({ h1 }),
  linkedTsp: undefined,
  setLinkedTsp: (tsp) => set({ linkedTsp: tsp }),
  countryVouchers: [],
  setCountryVouchers: (vouchers) => set({ countryVouchers: vouchers }),
  denominationsByCountry: {},
  setdenominationsByCountry: (vouchers) => set({ denominationsByCountry: vouchers }),
  paymentMethod: PaymentMethod.SBP,
  setPaymentMethod: (method) => set({ paymentMethod: method }),
  amountInfo: null,
  setAmountInfo: (amount) => set({ amountInfo: amount }),
  activeCountry: null,
  setActiveCountry: (country) => set({ activeCountry: country }),
  activeDenomination: null,
  setActiveDenomination: (denomination) => set({ activeDenomination: denomination }),
  activeCountrySteam: 'Россия',
  setActiveCountrySteam: (country) => set({ activeCountrySteam: country }),
  requestID: '',
  setRequestID: (requestID) => set({ requestID }),
  handleClickScrollToAccordion: () => {},
  setHandleClickScrollToAccordion: (fn) => set({ handleClickScrollToAccordion: fn }),
  isPaymentloading: false,
  isAmountInfoLoading: false,
  setPaymentLoading: (isPaymentloading) => set({ isPaymentloading }),
  setIsAmountInfoLoading: (isLoading) => set({ isAmountInfoLoading: isLoading }),
  pcekMdOrder: '',
  setPcekMdOrder: (mdOrder) => set({ pcekMdOrder: mdOrder }),
  servers: null,
  setServers: (servers) => set({ servers }),
  isPromocodeActivated: false,
  setIsPromocodeActivated: (isPromocodeActivated) => set({ isPromocodeActivated }),
  lastActivatedPromocode: '',
  setLastActivatedPromocode: (lastActivatedPromocode) => set({ lastActivatedPromocode }),
}))
